import { render } from "./ValoriParametriiSalarizare.vue?vue&type=template&id=e8d5ec12&scoped=true&ts=true"
import script from "./ValoriParametriiSalarizare.vue?vue&type=script&lang=ts"
export * from "./ValoriParametriiSalarizare.vue?vue&type=script&lang=ts"

import "./ValoriParametriiSalarizare.vue?vue&type=style&index=0&id=e8d5ec12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d5ec12"]])

export default __exports__